module.exports = __webpack_public_path__ + "static/media/cb.1d4831e2.png";